var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "app"
  }, [_c("div", {
    staticClass: "box"
  }, [_c("div", {
    staticClass: "left",
    style: {
      paddingBottom: _vm.showEnd ? "calcPx(72)" : "calcPx(0)"
    }
  }, _vm._l(_vm.List, function (item, index) {
    return index % 2 === 0 ? _c("div", {
      key: index,
      staticClass: "wapper",
      on: {
        click: function click($event) {
          return _vm.toProductDetails(item);
        }
      }
    }, [_c("commodity", {
      attrs: {
        item: item,
        index: index,
        type: _vm.type
      },
      on: {
        cancel: _vm.cancel
      }
    })], 1) : _vm._e();
  }), 0), _c("div", {
    staticClass: "right",
    style: {
      paddingBottom: _vm.showEnd ? "calcPx(72)" : "calcPx(0)"
    }
  }, _vm._l(_vm.List, function (item, index) {
    return index % 2 !== 0 ? _c("div", {
      key: index,
      staticClass: "wapper",
      on: {
        click: function click($event) {
          return _vm.toProductDetails(item);
        }
      }
    }, [_c("commodity", {
      attrs: {
        item: item,
        index: index,
        type: _vm.type
      },
      on: {
        cancel: _vm.cancel
      }
    })], 1) : _vm._e();
  }), 0)]), _vm.showEnd && _vm.scrollHeight && _vm.scrollHeight > 0 ? _c("div", {
    staticClass: "tips"
  }, [_vm._v(_vm._s(this.$t("my_collection.to_end")))]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };